"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareSearchConfig = exports.degreeOptions = exports.allCountries = exports.fosOptions = exports.toggleSearchTerm = exports.searchSectionName = exports.searchVisaOptions = exports.seniorityLevel = exports.seniorityName = exports.fieldOfStudyName = exports.anyValue = exports.maxRangeValue = exports.resultSortToString = exports.SearchStatus = exports.canUpdateSearch = exports.SearchProject = exports.getSimilarityScore = exports.SEARCH_PREVIEW_LIMIT = exports.BASELINE_SEARCH_SORT_RANK = void 0;
const lodash_1 = require("lodash");
const person_1 = require("./person");
const user_1 = require("./user");
exports.BASELINE_SEARCH_SORT_RANK = 0;
exports.SEARCH_PREVIEW_LIMIT = 250;
function getSimilarityScore(scores) {
    return (0, lodash_1.mean)(scores);
}
exports.getSimilarityScore = getSimilarityScore;
var SearchProject;
(function (SearchProject) {
    SearchProject["Titan"] = "titan";
    SearchProject["Hireflow"] = "hireflow";
    SearchProject["HireflowV2"] = "hireflow_v2";
})(SearchProject = exports.SearchProject || (exports.SearchProject = {}));
function canUpdateSearch(search, userId, userPermissions, accountManagerId) {
    if (!userId || !(search === null || search === void 0 ? void 0 : search.project))
        return false;
    return (search.project !== SearchProject.Titan ||
        userId === search.userId ||
        userId === accountManagerId ||
        (0, user_1.hasRole)(userPermissions, 'settings_editor'));
}
exports.canUpdateSearch = canUpdateSearch;
var SearchStatus;
(function (SearchStatus) {
    SearchStatus[SearchStatus["Initial"] = 1] = "Initial";
    SearchStatus[SearchStatus["Waiting"] = 2] = "Waiting";
    SearchStatus[SearchStatus["Caching"] = 3] = "Caching";
    SearchStatus[SearchStatus["Active"] = 4] = "Active";
    SearchStatus[SearchStatus["Complete"] = 5] = "Complete";
    SearchStatus[SearchStatus["Paused"] = 6] = "Paused";
    SearchStatus[SearchStatus["Aborted"] = 7] = "Aborted";
    SearchStatus[SearchStatus["InitFailed"] = 8] = "InitFailed";
    SearchStatus[SearchStatus["UpdatingProfiles"] = 9] = "UpdatingProfiles";
    SearchStatus[SearchStatus["ScoringProfiles"] = 10] = "ScoringProfiles";
    SearchStatus[SearchStatus["ScoringFailed"] = 11] = "ScoringFailed";
    SearchStatus[SearchStatus["Archived"] = 12] = "Archived";
    SearchStatus[SearchStatus["ResultsCached"] = 13] = "ResultsCached";
    SearchStatus[SearchStatus["TooManyResults"] = 14] = "TooManyResults";
})(SearchStatus = exports.SearchStatus || (exports.SearchStatus = {}));
function resultSortToString(sort) {
    switch (sort) {
        case 'skillScore':
            return 'Skill Score';
        case 'similarityScore':
            return 'Similarity Score';
        case 'totalScore':
            return 'Total Score';
        case 'random':
            return 'Random';
        case 'profileAge':
            return 'Profile Age';
        default:
            return sort;
    }
}
exports.resultSortToString = resultSortToString;
// search config types
exports.maxRangeValue = 99999;
exports.anyValue = 'any';
exports.fieldOfStudyName = {
    coding_major: 'Major with coding skills',
    computer_science: 'Computer Science',
    cs_and_related: 'CS and Related',
    engineering_non_cs: 'Engineering (Non CS)',
    management: 'Management',
    math_related: 'Math related'
};
exports.seniorityName = {
    director: 'Director',
    entry: 'Entry',
    executive: 'Executive',
    junior: 'Junior',
    normal: 'Normal',
    senior: 'Senior'
};
exports.seniorityLevel = {
    director: 4,
    entry: 0,
    executive: 5,
    junior: 1,
    normal: 2,
    senior: 3
};
const searchVisaOptions = () => {
    let options = (0, lodash_1.flatMap)(person_1.visaOptions, (v) => [`communications_${v}`, `user_${v}`]);
    options = options.concat(['linkedin_h1b', 'linkedin_tn_e3', 'linkedin_no_visa', 'unknown']);
    return options;
};
exports.searchVisaOptions = searchVisaOptions;
exports.searchSectionName = {
    anyPositionAndSummary: 'Any Job + Summary',
    anyPositionAndSummaryAndSkills: 'Any Job + Summary + Skills',
    anywhere: 'Anywhere in Profile',
    last1YearAndSummary: 'A Job in Last 1 Year + Summary',
    last3YearAndSummary: 'A Job in Last 3 Years + Summary',
    last5YearAndSummary: 'A Job in Last 5 Years + Summary',
    latestPosition: 'Latest Job',
    latestPositionAndSummary: 'Latest Job + Summary',
    softwareSmartScope: 'Smart Scope (Software)'
};
// search UI specific types/functions
function toggleSearchTerm(term, list) {
    const hasTerm = list.find((l) => (0, lodash_1.isEqual)(l, term));
    if (hasTerm) {
        return list.filter((l) => !(0, lodash_1.isEqual)(l, term));
    }
    else {
        return list.concat(term);
    }
}
exports.toggleSearchTerm = toggleSearchTerm;
exports.fosOptions = [
    'computer_science',
    'cs_and_related',
    'coding_major',
    'math_related',
    'engineering_non_cs',
    'management'
];
exports.allCountries = [exports.anyValue, 'USA', 'India', 'China', 'Canada', 'UK'].concat([
    'France',
    'Australia',
    'Mexico',
    'Chile',
    'Spain',
    'SouthKorea',
    'Germany',
    'Taiwan',
    'Italy',
    'Japan',
    'Brazil',
    'Turkey',
    'Israel',
    'Russian Federation',
    'Sweden',
    'Ireland',
    'Iran',
    'Pakistan',
    'Argentina',
    'Singapore',
    'Egypt',
    'Philippines',
    'Denmark',
    'Netherlands',
    'Ukraine',
    'New Zealand',
    'Switzerland',
    'Belgium',
    'Belarus',
    'Norway',
    'Bangladesh',
    'Bulgaria',
    'Austria',
    'Poland',
    'Romania',
    'Czech Republic',
    'Colombia',
    'Cuba',
    'Sri Lanka',
    'Hungary',
    'Portugal',
    'South Africa',
    'Serbia',
    'Greece',
    'Peru',
    'Nigeria',
    'Lebanon',
    'Korea',
    'Armenia',
    'Ethiopia',
    'Finland',
    'Venezuela'
].sort((s1, s2) => (s1 > s2 ? 1 : -1)));
exports.degreeOptions = [
    { value: 'none', name: 'None' },
    { value: 'bachelors', name: 'Bachelors' },
    { value: 'masters', name: 'Masters' },
    { value: 'phd', name: 'PhD' }
];
function compareSearchConfig(search1, search2) {
    const ignoreFields = {
        general: { resultsSort: '' }
    };
    const search1Config = (0, lodash_1.merge)({}, search1, ignoreFields);
    const search2Config = (0, lodash_1.merge)({}, search2, ignoreFields);
    const configChanged = !(0, lodash_1.isEqual)(search1Config, search2Config);
    return configChanged;
}
exports.compareSearchConfig = compareSearchConfig;
//# sourceMappingURL=search.js.map